import { render, staticRenderFns } from "./DmhTransactionCancelled.vue?vue&type=template&id=b90ae4f4"
import script from "./DmhTransactionCancelled.vue?vue&type=script&lang=js"
export * from "./DmhTransactionCancelled.vue?vue&type=script&lang=js"
import style0 from "./DmhTransactionCancelled.vue?vue&type=style&index=0&id=b90ae4f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports